var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    zoomAndPan: "magnify",
    viewBox: "0 0 37.5 37.499999",
    height: 50,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "2ec026d890"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.097656 10 L 35.886719 10 L 35.886719 29.210938 L 1.097656 29.210938 Z M 1.097656 10 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2ec026d890)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#143271",
    d: "M 33.917969 10 C 33.390625 10.015625 32.941406 10.210938 32.574219 10.59375 L 18.492188 24.675781 L 4.414062 10.59375 C 4.035156 10.203125 3.574219 10.007812 3.027344 10.007812 C 2.636719 10.007812 2.277344 10.121094 1.953125 10.339844 C 1.625 10.558594 1.390625 10.851562 1.242188 11.214844 C 1.09375 11.578125 1.058594 11.953125 1.140625 12.335938 C 1.21875 12.722656 1.402344 13.050781 1.683594 13.324219 L 17.128906 28.769531 C 17.308594 28.949219 17.519531 29.089844 17.753906 29.1875 C 17.992188 29.285156 18.238281 29.335938 18.492188 29.335938 C 18.75 29.335938 18.996094 29.285156 19.230469 29.1875 C 19.46875 29.089844 19.675781 28.949219 19.859375 28.769531 L 35.304688 13.324219 C 35.589844 13.046875 35.773438 12.714844 35.855469 12.324219 C 35.9375 11.9375 35.902344 11.558594 35.746094 11.191406 C 35.59375 10.824219 35.351562 10.53125 35.015625 10.3125 C 34.683594 10.097656 34.316406 9.992188 33.917969 10 Z M 33.917969 10 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.0679651b8303f08c0a958f27650360fd.svg";
export { ForwardRef as ReactComponent };